import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { ChipList, ChipTextField } from "../../../../components/form";
import { APP_COLORS } from "../../../../enums";
import { useAppSelector } from "../../../../store";

function TechnologyStackFilter({ onFilterChange }) {
  const categories = useAppSelector((state) => state.lists.categories);
  const [selectedList, setSelectedList] = useState([]);

  useEffect(() => {
    onFilterChange(selectedList);
  }, [selectedList]);

  const handleOnChange = (e) => {
    setSelectedList(e.target.value);
  };

  const onFilterDelete = (e) => {
    const tempList = [...selectedList];

    tempList.splice(e.index, 1);

    setSelectedList(tempList);
  };

  return (
    <>
      <ChipList
        chipProps={{
          size: "small",
          variant: "outlined",
          sx: {
            backgroundColor: "white",
            border: `1px solid ${APP_COLORS.secondary}`,
          },
        }}
        onDelete={onFilterDelete}
        list={selectedList}
        flatList
      />
      <Box sx={{ bgcolor: "white" }}>
        <ChipTextField
          inputProps={{
            id: "category",
            name: "category",
            value: selectedList,
            onChange: handleOnChange,
            placeholder: "Category",
            variant: "outlined",
          }}
          labelProps={{
            label: "Category",
          }}
          renderTags={false}
          options={categories?.data}
          rootProps={{ sx: { margin: 0 } }}
          chipTextFieldListConfig={{
            labelField: "label",
            valueField: "label",
          }}
        />
      </Box>
    </>
  );
}

export default TechnologyStackFilter;
